export type PageMeta = {
  sectionKey: string;
  pageKey: string;
  subPageKey?: string;
  detailKey?: string;
};

const ROUTE_META: Array<{ prefix: string; meta: PageMeta }> = [
  { prefix: "/dashboard", meta: { sectionKey: "nav.section.operate", pageKey: "nav.dashboard" } },
  { prefix: "/devices", meta: { sectionKey: "nav.section.operate", pageKey: "nav.devices" } },
  { prefix: "/employees", meta: { sectionKey: "nav.section.operate", pageKey: "nav.employees" } },
  { prefix: "/enrollment", meta: { sectionKey: "nav.section.operate", pageKey: "nav.enrollment" } },
  { prefix: "/insights", meta: { sectionKey: "nav.section.insights", pageKey: "nav.insights" } },
  { prefix: "/reports", meta: { sectionKey: "nav.section.insights", pageKey: "nav.reports" } },
  { prefix: "/rules", meta: { sectionKey: "nav.section.govern", pageKey: "nav.rules" } },
  { prefix: "/policies", meta: { sectionKey: "nav.section.govern", pageKey: "nav.policies" } },
  { prefix: "/users", meta: { sectionKey: "nav.section.admin", pageKey: "nav.users" } },
  { prefix: "/audit", meta: { sectionKey: "nav.section.admin", pageKey: "nav.audit" } },
  { prefix: "/settings", meta: { sectionKey: "nav.section.admin", pageKey: "nav.settings" } },
  { prefix: "/config", meta: { sectionKey: "nav.section.admin", pageKey: "nav.config" } },
];

const DETAIL_SUFFIXES: Array<{ pattern: RegExp; detailKey: string }> = [
  { pattern: /^\/devices\/[^/]+$/, detailKey: "layout.detail" },
  { pattern: /^\/enrollment\/batches\/[^/]+$/, detailKey: "layout.detail" },
  { pattern: /^\/users\/new$/, detailKey: "layout.new" },
  { pattern: /^\/users\/[^/]+$/, detailKey: "layout.edit" },
];

function resolvePathOverrides(pathname: string): Pick<PageMeta, "subPageKey" | "detailKey"> {
  if (pathname === "/policies/schedules") {
    return { subPageKey: "schedules.list.title" };
  }
  if (pathname === "/policies/schedules/new") {
    return { subPageKey: "schedules.list.title", detailKey: "layout.new" };
  }
  if (/^\/policies\/schedules\/[^/]+$/.test(pathname)) {
    return { subPageKey: "schedules.list.title", detailKey: "layout.edit" };
  }
  if (pathname === "/reports/device-health") {
    return { subPageKey: "reports.deviceHealth.title" };
  }
  if (pathname === "/reports/app-adoption") {
    return { subPageKey: "reports.appAdoption.title" };
  }
  return {};
}

export function resolvePageMeta(pathname: string): PageMeta | null {
  const sorted = [...ROUTE_META].sort((a, b) => b.prefix.length - a.prefix.length);
  const base = sorted.find((entry) => pathname === entry.prefix || pathname.startsWith(`${entry.prefix}/`));
  if (!base) return null;

  const overrides = resolvePathOverrides(pathname);
  const detail = DETAIL_SUFFIXES.find((d) => d.pattern.test(pathname));
  const detailKey =
    overrides.detailKey ?? (detail && pathname !== base.prefix ? detail.detailKey : undefined);

  return {
    ...base.meta,
    ...overrides,
    detailKey,
  };
}
